import CallAPI from "../../utility/functions/getData";
import {
  setAlertWithTitle,
  setSpinnerLoading,
} from "../../utility/Redux/modal";
import dataToLocal from "../../utility/component/dataToLocal";
import deleteWholeDatabase from "../../utility/functions/deleteWholeDatabase";

export const GetPurchaseSummary = (data, token, dispatch, setPurchaseList,setTotalPages,setCurrentPage) => {
  dispatch(setSpinnerLoading("Getting purchase summary"));
  deleteWholeDatabase("debit_note_report");
  CallAPI(
    "/api/debitNote/listDebitNote",
    data,
    token,
    (e) => {
      if (!e.data.error) {
    
        const res = e.data.response.data;
        setTotalPages(e.data.response?.totalPages)
        setCurrentPage(e.data.response?.currentPage)
        if (res[0]) {
          setPurchaseList(res);
          dataToLocal("debit_note_report", res, [
            {
              ...data,
              ICODE: 1,
            },
          ]);
        } else {
          setPurchaseList([]);

          dispatch(
            setAlertWithTitle({
              title: "Alert",
              msg: "No Records found",
            })
          );
        }
      } else {
        dispatch(
          setAlertWithTitle({
            title: "Alert",
            msg: "Something Went Wrong.",
          })
        );
      }
    },
    dispatch,
    () => {
      dispatch(setSpinnerLoading(false));
    }
  );
};
